/**
 * Registry barrel.
 *
 * Public surface for consumers (resolver, ScopePage, ranker) — everything
 * else should live under this folder. New features add themselves by
 * editing only `features.ts`.
 */
import type { Command, SearchProvider } from "../types";
import { FEATURE_PALETTES } from "./features";

export { ALL_SCOPES, getScope, getChildren, getScopeChain, scopeFromPathname } from "./scopes";

export const ALL_COMMANDS: Command[] = FEATURE_PALETTES.flatMap((f) => f.commands ?? []);

export const ALL_PROVIDERS: SearchProvider[] = FEATURE_PALETTES.flatMap(
  (f) => f.searchProviders ?? [],
);
